import React, { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import CookieConsent from "./components/CookieConsent";
import About from "./pages/About";
import Showcase from "./pages/showcase";
import ShowcaseDetails from "./pages/showcase/ShowcaseDetails";
import BlogDetails from "./pages/BlogDetails";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Portfolio from "./pages/Portfolio";
import Resume from "./pages/Resume";
import Services from "./pages/Services";
import ClientPreview from "./pages/ClientPreview";

interface Props {
  // Add any props that are passed to the App component here
}

const App: React.FC<Props> = () => {
  const [lightMode, setLightMode] = useState<boolean>(false);

  lightMode
    ? document.body.classList.add("light")
    : document.body.classList.remove("light");

  const handleMode = (): void => {
    if (!lightMode) {
      setLightMode(true);
      document.body.classList.add("light");
    } else {
      setLightMode(false);
      document.body.classList.remove("light");
    }
  };

  return (
    <BrowserRouter>
      <div className="light-mode">
        <span className="icon">
          {lightMode ? (
            <Sun className="text-yellow-400" size={24} />
          ) : (
            <Moon className="text-indigo-400" size={24} />
          )}
        </span>

        <label className="theme-toggle">
          <input type="checkbox" checked={!lightMode} onChange={handleMode} />
          <span className="slider"></span>
        </label>
      </div>
      <Routes>
        <Route path="/" element={<Home lightMode={lightMode} />} />
        <Route path="about" element={<About />} />
        <Route path="services" element={<Services />} />
        <Route path="cv" element={<Resume />} />
        <Route path="portfolio" element={<Portfolio />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:id/:title" element={<BlogDetails />} />
        <Route path="showcase" element={<Showcase />} />
        <Route path="showcase/:title" element={<ShowcaseDetails />} />
        <Route path="contact" element={<Contact />} />
        <Route
          path="client/:clientName"
          element={<ClientPreview lightMode={lightMode} />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
};

export default App;
